<div class="container">
  <!-- <div id="legend-container_{{ id }}"></div> -->

  <div class="canvas-container" dir="ltr">
    <canvas
      id="{{ chartId }}"
      [attr.width]="size"
      [attr.height]="size"
    ></canvas>
  </div>

  <div class="center-el" *ngIf="centerContent">
    <ng-container *ngTemplateOutlet="centerContent"></ng-container>
  </div>
</div>
